import * as React from "react";

const SpeakerUnmuted = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#64748B"
      d="M11.689 2.59a.575.575 0 0 0-.605.063L6.067 6.554h-3.25a1.15 1.15 0 0 0-1.15 1.15V12.3a1.15 1.15 0 0 0 1.15 1.15h3.25l5.017 3.901a.575.575 0 0 0 .928-.453V3.106a.574.574 0 0 0-.323-.517ZM2.816 7.703H5.69V12.3H2.816V7.704Zm8.046 8.02L6.84 12.595V7.41l4.023-3.129v11.443Zm3.88-7.621a2.874 2.874 0 0 1 0 3.799.574.574 0 0 1-.863-.76 1.724 1.724 0 0 0 0-2.279.575.575 0 0 1 .863-.76Zm3.591 1.9a5.74 5.74 0 0 1-1.463 3.831.575.575 0 0 1-.856-.766 4.598 4.598 0 0 0 0-6.13.575.575 0 1 1 .856-.767 5.735 5.735 0 0 1 1.463 3.831Z"
    />
  </svg>
);
export default SpeakerUnmuted;
